import React from 'react';

const VerifiedIcon = (props: object) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.38203 23.618C5.30391 22.5398 6.01875 20.2746 5.47031 18.948C4.90078 17.5781 2.8125 16.4648 2.8125 15C2.8125 13.5352 4.90078 12.4219 5.47031 11.052C6.01875 9.72656 5.30391 7.46016 6.38203 6.38203C7.46016 5.30391 9.72656 6.01875 11.052 5.47031C12.4277 4.90078 13.5352 2.8125 15 2.8125C16.4648 2.8125 17.5781 4.90078 18.948 5.47031C20.2746 6.01875 22.5398 5.30391 23.618 6.38203C24.6961 7.46016 23.9813 9.72539 24.5297 11.052C25.0992 12.4277 27.1875 13.5352 27.1875 15C27.1875 16.4648 25.0992 17.5781 24.5297 18.948C23.9813 20.2746 24.6961 22.5398 23.618 23.618C22.5398 24.6961 20.2746 23.9813 18.948 24.5297C17.5781 25.0992 16.4648 27.1875 15 27.1875C13.5352 27.1875 12.4219 25.0992 11.052 24.5297C9.72656 23.9813 7.46016 24.6961 6.38203 23.618Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3125 15.9375L13.125 18.75L19.6875 12.1875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VerifiedIcon;
